import React from "react";
import { Link } from "react-router-dom";
import { services } from "../data/services";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";

const Palvelut = () => {
  const { lang } = useLang();
  const tr = pick(lang);

  return (
    <article className="page page--palvelut">
      <div className="page__inner">
        <header className="page__header">
          <h1 className="page__title">{tr(t.palvelut.title)}</h1>
          <p className="page__intro">{tr(t.palvelut.intro1)}</p>
          <p className="page__intro">{tr(t.palvelut.intro2)}</p>
        </header>

        <section className="page__section">
          <h2 className="page__subtitle">{tr(t.palvelut.whatWeDo)}</h2>
          <ul className="services">
            {services.map((s) => {
              const ts = t.services[s.id] || {};
              return (
                <li key={s.id} className="services__item">
                  <h3 className="services__name">{tr(ts.name)}</h3>
                  <p className="services__desc">{tr(ts.description)}</p>
                </li>
              );
            })}
          </ul>
        </section>

        <section className="page__section page__cta">
          <h2 className="page__subtitle">{tr(t.palvelut.ctaTitle)}</h2>
          <p className="page__intro">{tr(t.palvelut.ctaBody)}</p>
          <Link to="/yhteys" className="teaser__link">
            {tr(t.palvelut.ctaLink)}
          </Link>
        </section>
      </div>
    </article>
  );
};

export default Palvelut;
